import { useEffect, useState } from "react";

// ─── The one route in the app ────────────────────────────────────────────────
// There is no router here: index.js decides what to render from session state
// alone. The privacy policy is the first screen that has to be reachable by
// URL — a legal document has to be readable before signing up, and linkable
// from the marketing site.
//
// It lives in the hash, not the path, on purpose. A path like /privacy would
// 404 on Netlify: this project publishes a static build with no `_redirects`
// and no `[[redirects]]`, so an unknown path never reaches index.html. The hash
// is never sent to the server, so #/privacy works with no deploy change at all.
// When a real router arrives, this moves to a clean path in one place.
//
// Safe alongside the auth flow: useAuth.js reads the hash too, but only tests
// for `type=recovery`, which #/privacy cannot match.
export const PRIVACY_HASH = "#/privacy";

export function openPrivacy() {
  window.location.hash = PRIVACY_HASH;
}

// Closing replaces the entry instead of calling history.back(). Back would walk
// off the site for anyone who arrived on #/privacy directly from a link, which
// is exactly the visitor this page exists for. replaceState does not fire
// hashchange, so the listeners are notified by hand.
export function closePrivacy() {
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
  window.dispatchEvent(new Event("hashchange"));
}

export function usePrivacyRoute() {
  const [open, setOpen] = useState(() =>
    typeof window !== "undefined" && window.location.hash === PRIVACY_HASH);

  useEffect(() => {
    const sync = () => setOpen(window.location.hash === PRIVACY_HASH);
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, []);

  return open;
}
